export const WEB_RUNTIME = {
  APP_LOGO_COLOR_TEXT: require('../../../../assets/images/logo_xselly.png'),
  APP_LOGO_WHITE_TEXT: require('../../../../assets/images/logo_xselly_white.png'),
}
